import React, { useState, useEffect } from "react";
import CustomModal from "../../../common-utilities/core/modal";
import "./index.scss";
import { useParams } from "react-router";
import {
  convertToCamelCaseFromUnderScore,
  formatDate,
} from "../../../common-utilities/utils";
import { DATE_FORMATS } from "../../../common-utilities/utils/constants";
import {
  IconButton,
  Button,
  TextareaAutosize,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { getOfflineData } from "../../../common-utilities/utils/offline-services";
import { invokeApi } from "../../utils/http-service";
import { technetEndPoint } from "../../../common-utilities/utils/end-points/tech-net";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/tech-net";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokenMainKeys } from "../../../../utils/constants";
import { HTTP_METHODS } from "../../../common-utilities/utils/http-service";
import SelectComponent from "../../../common-utilities/core/select-component";
import CommonBtn from "../../../common-utilities/core/common-button";
import AutocompleteComponent from "../../../common-utilities/core/styled-autocomplete";
import { editCatConfig, getFormConfig } from "../create-ticket/helper";
import { getAllTicketCategoriesForaParent } from "../create-ticket/data-apis";
import { CategoryDoc } from "../TicketCategory/sub-components/category-doc.subcomponent";
const sx = {
  input: {
    background: "#fff",
    borderColor: "gray",
  },
};
const BasicInfo = ({
  ticketDetails,
  reloadData,
  onDateChange,
  storeDetails,
}) => {
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const user = getOfflineData(tokenMainKeys.technet, "user");
  const [adminAndTechNetUsersList, setadminAndTechNetUsersList] = useState([]);
  const [engineer, setEngineer] = useState(null);
  const [reAssignedComment, setReAssignedComment] = useState("");
  const [reassign, setReassign] = useState(false);
  const [updateCat, setUpdateCat] = useState(false);
  const [updateCritical, setUpdateCritical] = useState(false);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [ticketCategoriesList, setticketCategoriesList] = useState([]);
  const [updateCatObj, setUpdateCatObj] = useState({});
  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    if (user.type === "AM") {
      invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.AM_STORE_USER_LIST}`)
        .then((response) => {
          if (response?.message) {
            return;
          }
          const allStoreUsers = response?.storeUsers?.map((item) => {
            return { label: item.fullName, value: item.id };
          });
          setadminAndTechNetUsersList(allStoreUsers);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      invokeApi(
        HTTP_METHODS.GET,
        `${HOSTNAME}${REST_URLS.ADMINANDTECHNETUSERSLIST}`,
        null,
        {
          getAgent: true,
        }
      )
        .then((response) => {
          if (response?.message) {
            return;
          }
          const allTechNetAndAdminUsers = response.map((item) => {
            return { label: item.name, value: item.id };
          });
          setadminAndTechNetUsersList(allTechNetAndAdminUsers);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const reAssignEnginner = () => {
    setReassign(false);
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.REASSIGNENGINEER}/${id}`,
      { assignedTo: engineer.value, assignedToComment: reAssignedComment }
    )
      .then((response) => {
        if (response.success === true) {
          toast.success("Engineer reassigned successfully");
          navigate(`${technetEndPoint}/tickets`);
          loadData();
          if (onDateChange) {
            onDateChange();
          }
          reloadData();
        } else {
          toast.error("Sorry something went wrong");
        }
        setReassign(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTicketCategoriesByCurrentDepartment = (parentNull = true) => {
    const params = { showZeroEscalation: true };
    if (parentNull) {
      params.parentNull = true;
    }
    if (ticketDetails?.StoresList?.value) {
      params.store = ticketDetails?.StoresList?.value;
    }
    const dept = ticketDetails?.ticket?.dept?.id;
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_CATEGORY_DEPARTMENT_WISE}${dept}`,
      null,
      params
    )
      .then((response) => {
        if (!response?.message) {
          const ticketCategoriesList = response.map((item) => {
            const { name, id, attachments } = item;
            return { label: name, value: id, attachments: attachments || [] };
          });
          setticketCategoriesList(ticketCategoriesList);
        }
      })
      .catch((err) => console.log(err));
  };
  const onInputChange = (event) => {
    const isParentCategorySelected = event.target.name === "ticketcategory";
    const isSubCategorySelected = event.target.name === "ticketsubcategory";
    let valueToRemoveOnResetting = {};
    if (isParentCategorySelected) {
      const parentValue = event?.target?.value?.value;
      const isValueSelected = !!parentValue;
      if (isValueSelected) {
        getAllTicketCategoriesForaParent(
          parentValue,
          setSubCategoryList,
          ticketDetails?.StoresList?.value
        );
      }
      valueToRemoveOnResetting.ticketsubcategory = null;
      valueToRemoveOnResetting.categoryAttachments = [];
    }

    if (isSubCategorySelected) {
      valueToRemoveOnResetting.categoryAttachments = [];
    }
    setUpdateCatObj({
      ...updateCatObj,
      ...valueToRemoveOnResetting,
      [event.target.name]: event.target.value,
    });
  };
  const inputElements = (config) => {
    return (
      <div className="form-row" key={config.label}>
        <span className="label">{config.label}</span>
        {config.type === "select" ? (
          <div>
            <AutocompleteComponent
              label="Select..."
              onChange={(e, value) => {
                onInputChange({
                  target: {
                    name: config.name,
                    value: value,
                  },
                });
              }}
              options={config.options}
              disableClear={true}
              value={config?.value || null}
            />

            <div className="danger-text"> {config.helperText}</div>
          </div>
        ) : config.type === "text" || config.type === "number" ? (
          <TextField
            size="small"
            value={config.value}
            name={config.name}
            type={config.type}
            sx={{ ...sx, width: "100%" }}
            onChange={onInputChange}
            className="new-textfield"
            error={config.error}
            helperText={config.error ? "Required" : ""}
          />
        ) : config.type === "categoryAttachments" ? (
          <>
            <CategoryDoc
              showModal={false}
              mainSetData={setUpdateCatObj}
              fileDetails={config.details}
              errorMsg={config.error ? "Required" : ""}
              data={updateCatObj}
              attachmentKey="categoryAttachments"
            />
          </>
        ) : (
          <TextField
            size="small"
            value={config.value}
            name={config.name}
            type={config.type}
            sx={{ ...sx, width: "100%" }}
            onChange={onInputChange}
            error={config.error}
            className="new-textfield"
            helperText={config.error ? "Required" : ""}
            multiline
            rows={10}
          />
        )}
      </div>
    );
  };
  const resetUpdate = () => {
    setUpdateCatObj({});
    setUpdateCat(false);
    setSubCategoryList([]);
    setticketCategoriesList([]);
    setUpdateCritical(false);
  };
  const updateTicketDetails = ({ isCriticalUpdate = false }) => {
    let payload;
    if (isCriticalUpdate) {
      payload = {
        critical: updateCatObj.critical,
      };
    } else {
      const category = updateCatObj?.ticketsubcategory?.value
        ? parseInt(updateCatObj.ticketsubcategory.value)
        : parseInt(updateCatObj.ticketcategory.value);
      payload = {
        category,
        categoryAttachments: updateCatObj?.categoryAttachments || [],
      };
    }

    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.UPDATETICKET}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response?.message);
        } else {
          toast.success("Ticket updated successfully");
          resetUpdate();
          onDateChange();
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <Grid container md={12} xs={12} className="basic-info-container">
      <Grid md={user && user.type !== "STORE_OWNER" ? 2 : 3} xs={12}>
        <div className="inputs">
          <div className="info-section">
            <div>Ticket id: </div>
            <div className="value"> {id.substr(0, 8)}</div>
          </div>
          <div className="info-section">
            <span>Created At:</span>
            <div className="value">
              {formatDate(
                ticketDetails?.createdAt,
                DATE_FORMATS["MMM DD YYYY hh:MM"]
              )}
            </div>
          </div>
          <div className="info-section">
            <span> Contact Person:</span>
            <div className="value">
              {storeDetails &&
                storeDetails?.contactPerson &&
                `${storeDetails.contactPerson}`}
            </div>
          </div>
        </div>
      </Grid>
      <Grid md={user && user.type !== "STORE_OWNER" ? 2 : 3} xs={12}>
        <div className="inputs">
          <div className="info-section">
            <div>Ticket Status:</div>
            <div className="value">
              {ticketDetails &&
              ticketDetails.ticket &&
              ticketDetails.ticket.status
                ? convertToCamelCaseFromUnderScore(ticketDetails.ticket.status)
                : ""}
            </div>
          </div>

          <div className="info-section">
            <span>Department:</span>
            <div className="value">
              {ticketDetails &&
                ticketDetails.ticket &&
                `${ticketDetails.ticket.dept?.name}`}
            </div>
          </div>
        </div>
        <div className="info-section">
          <span>Contact Number:</span>
          <div className="value">
            {storeDetails &&
              storeDetails?.storeContact &&
              `${storeDetails.storeContact}`}
          </div>
        </div>
      </Grid>
      <Grid md={user && user.type !== "STORE_OWNER" ? 2 : 3} xs={12}>
        <div className="inputs">
          <div className="info-section">
            <span>Category:</span>
            <div className="value">
              {ticketDetails &&
                ticketDetails.ticket &&
                `${ticketDetails.ticket.category?.name}`}
              {ticketDetails?.updateRights && (
                <IconButton
                  size="small"
                  fontSize="12"
                  onClick={() => {
                    setUpdateCat(true);
                    getTicketCategoriesByCurrentDepartment();
                  }}
                  disabled={ticketDetails?.ticket?.status === "RESOLVED"}
                >
                  <EditIcon fontSize="12" color="primary" />
                </IconButton>
              )}
            </div>
          </div>
          <div className="info-section">
            <span>SLA Expiry:</span>
            <div className="value">
              {ticketDetails &&
                ticketDetails.ticket &&
                `${formatDate(
                  ticketDetails?.ticket?.slaExpiry,
                  DATE_FORMATS["MMM DD YYYY hh:MM"]
                )}`}
            </div>
          </div>
          <div className="info-section">
            <span>Is Critical:</span>
            <div className="value">
              {ticketDetails && ticketDetails?.ticket?.critical ? `Yes` : "No"}
              {ticketDetails?.updateRights && (
                <IconButton
                  size="small"
                  fontSize="12"
                  onClick={() => {
                    setUpdateCatObj({
                      critical: ticketDetails?.ticket?.critical,
                    });
                    setUpdateCritical(true);
                  }}
                >
                  <EditIcon fontSize="12" color="primary" />
                </IconButton>
              )}
            </div>
          </div>
        </div>
      </Grid>

      <div className="inputs">
        {user && user.type !== "STORE_OWNER" && (
          <>
            <Grid md={user && user.type !== "STORE_OWNER" && 12} xs={12}>
              <div className="info-section">
                <span>Support Person:</span>
                <div className="value space-between">
                  {ticketDetails &&
                    ticketDetails.ticket &&
                    ticketDetails.ticket.assignedTo &&
                    ticketDetails.ticket.assignedTo?.name}
                  {(ticketDetails?.updateRights || user.type === "AM") && (
                    <IconButton
                      size="small"
                      fontSize="12"
                      onClick={() => setReassign(true)}
                      disabled={ticketDetails?.ticket?.status === "RESOLVED"}
                    >
                      <EditIcon fontSize="12" color="primary" />
                    </IconButton>
                  )}
                </div>
              </div>

              <div className="info-section">
                <span>Store Number:</span>
                <div className="value">
                  {storeDetails &&
                    storeDetails?.storeNumber &&
                    `${storeDetails.storeNumber}`}
                </div>
              </div>
            </Grid>
          </>
        )}
        {updateCat && (
          <CustomModal
            classesToPreventClosing={[
              "MuiButtonBase-root",
              "MuiMenuItem-root",
              "MuiAutocomplete-option",
              "Mui-focused",
            ]}
            title="Update Category"
            onClose={() => resetUpdate()}
          >
            <div className="reassign-container">
              {editCatConfig(
                updateCatObj,
                ticketCategoriesList,
                subCategoryList
              ).map((config) => {
                return inputElements(config);
              })}
              <CommonBtn
                fullWidth
                variant="contained"
                className="button-color"
                size="small"
                disabled={!updateCatObj?.ticketcategory?.value}
                onClick={() => updateTicketDetails({ isCriticalUpdate: false })}
              >
                Update details
              </CommonBtn>
            </div>
          </CustomModal>
        )}
        {updateCritical && (
          <CustomModal
            classesToPreventClosing={[
              "MuiButtonBase-root",
              "MuiMenuItem-root",
              "MuiAutocomplete-option",
              "Mui-focused",
            ]}
            title="Is Ticket Critical?"
            onClose={() => {
              resetUpdate();
              setUpdateCatObj({});
            }}
          >
            <div className="reassign-container">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!updateCatObj?.critical}
                    name="critical"
                    onChange={(e) =>
                      setUpdateCatObj({
                        critical: e.target.checked,
                      })
                    }
                  />
                }
                label="Is Critical"
              />
              <CommonBtn
                fullWidth
                variant="contained"
                className="button-color"
                size="small"
                onClick={() => updateTicketDetails({ isCriticalUpdate: true })}
              >
                Update details
              </CommonBtn>
            </div>
          </CustomModal>
        )}
        {reassign && (
          <CustomModal
            classesToPreventClosing={[
              "MuiButtonBase-root",
              "MuiMenuItem-root",
              "MuiAutocomplete-option",
              "Mui-focused",
            ]}
            title="Reassign"
            onClose={() => setReassign(false)}
          >
            <div className="reassign-container">
              <div>Support Person</div>
              <AutocompleteComponent
                onChange={(e, val) => {
                  const engr = adminAndTechNetUsersList.find(
                    (item) => item.value === val?.value
                  );
                  setEngineer(engr || null);
                }}
                label="Select Support Person"
                value={engineer || null}
                options={adminAndTechNetUsersList}
                getOptionLabel={(option) => option?.label}
              />
              {/* <SelectComponent
                onChange={(e, val) => {
                  const engr = adminAndTechNetUsersList.find(
                    (item) => item.value === e.target.value
                  );
                  setEngineer(engr || null);
                }}
                label="Select Support Person"
                value={engineer?.value || null}
                options={adminAndTechNetUsersList}
              /> */}
              <TextareaAutosize
                placeholder="Comment"
                minRows={5}
                fullWidth
                onChange={(e) => setReAssignedComment(e.target.value)}
              ></TextareaAutosize>
              <CommonBtn
                fullWidth
                variant="contained"
                className="button-color"
                size="small"
                disabled={!(engineer && engineer.value)}
                onClick={reAssignEnginner}
              >
                Update details
              </CommonBtn>
            </div>
          </CustomModal>
        )}
      </div>
    </Grid>
  );
};

export default BasicInfo;
